import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
  Checkbox,
  IconButton,
  Collapse,
  Box,
  Table,
  TableRow,
  withStyles,
  TableCell,
  Button,
  MenuItem,
  Select,
  InputLabel,
  Input,
  TextField,
  FormControl,
  ListItemText,
  Typography,
} from "@material-ui/core";

import moment from "moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import {
  Toast,
  SimpleToolbar,
  AssignProduct,
  Loader,
  ConfirmationModal,
  Drawer,
  BaseTable,
  StyledTableCell,
  StyledTableRow,
} from "../components";
import { AuthContext } from "../context";
import { orderServices, productsServices } from "../services";
import { useDrawer } from "../hooks";

import EmailIcon from "@material-ui/icons/Email";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ResendEmailModal from "../components/resend-assignment-to-patient-modal";
import { EditStatusModal } from "../components/edit-status-modal";
import ClearIcon from "@material-ui/icons/Clear";
import getComunas from "../helpers/get-comunas";
import handleDownloadExcel from "../helpers/handle-download-excel";
import {
  capitalizeFirstLetterArray,
  getAssignmentStatusNames,
} from "../helpers";
const comunasArray = getComunas();
const StyledTableCell2 = withStyles((theme) => ({
  head: {
    minWidth: 170,
  },
}))(TableCell);

const HandleResendEmailModal = ({ assignment, index }) => {
  const [openResendEmailModal, setOpenResendEmailModal] = useState(false);

  return (
    <>
      <ResendEmailModal
        assigment={assignment}
        open={openResendEmailModal}
        onClose={() => setOpenResendEmailModal(false)}
      />
      <IconButton
        onClick={() => setOpenResendEmailModal(true)}
        style={{ margin: "auto 0", width: "2rem", height: "2rem" }}
      >
        <EmailIcon color="primary" />
      </IconButton>
    </>
  );
};

function getComuna(cadena) {
  if (!cadena) {
    return "No especficada por el paciente";
  }

  let partes = "";

  if (typeof cadena === "string") {
    partes = cadena.split(",");
    if (partes.length >= 3) return partes[2].trim();
  }

  return cadena.comuna;
}

const tableHeader = [
  "nombre del paciente",
  "rut del paciente",
  "tlf del paciente",
  "email del paciente",
  "nombre del doctor",
  "rut del doctor",
  "email del doctor",
  "direccion",
  "creacion",
  "ultima modificacion",
  "productos",
  "estatus",
];

const today = moment().format("YYYY-MM-DD");
export default function AssignmentsToPatientsScreen(props) {
  const classes = useStyles();
  const { authState, signOut } = useContext(AuthContext);
  const [productsAssigned, setProductsAssigned] = useState([]);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [openModalAsign, setOpenModalAsign] = useState(false);
  const [reload, setReload] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const { isOpen, setIsOpen } = useDrawer();
  const [openModal, setOpenModal] = useState(false);
  const [assigmentId, setAssingmentId] = useState(null);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [selectedOrderStatus, setSelectedOrder] = useState("");
  // const [update, setUpdate] = useState(false);
  const [selectedComunas, setSelectedComunas] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assignment, setAssignment] = useState(null);
  const searchedText = useRef("");
  const tableBody = useRef([]);
  const [loadingOrderStatusUpdates, setLoadingOrderStatusUpdates] = useState(
    []
  );
  const isFirstRender = useRef(true);
  const {
    user: {
      role: { name: roleName },
    },
  } = authState;
  const getAllOrdersStatus = async () => {
    try {
      const response = await orderServices.getAllOrdersStatus({
        token: authState.token,
      });
      setOrderStatuses(response.data);
    } catch (error) {
      console.error("Error al obtener los estados de las ordenes:", error);
    }
  };
  useEffect(() => getAllOrdersStatus(), []);

  const getProductsAssigned = async (text = "") => {
    try {
      if (isFirstRender.current) {
        setLoading(true);
        isFirstRender.current = false;
      }

      const apiStartDate = startDate
        ? moment(startDate).format("YYYY-MM-DD")
        : "";
      const apiEndDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

      const { status, response } = await productsServices.getAllAssignProducts({
        page,
        limit,
        token: authState.token,
        text,
        comuna: selectedComunas,
        estado: selectedOrderStatus,
        startDate: apiStartDate,
        endDate: apiEndDate,
      });
      if (status === 200) {
        setProductsAssigned(response.data);
        setCount(response.pageInfo[0].count);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const onDelete = async () => {
    try {
    } catch (e) {
      console.log(e);
    }
  };

  const removeFilters = () => {
    setSelectedComunas([]);
    setSelectedOrder("");
    setStartDate(null);
    setEndDate(null);
    getProductsAssigned(searchedText.current);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedProductIds.indexOf(id);
    let newSelectedProductIds = [];

    if (selectedIndex === -1) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds,
        id
      );
    } else if (selectedIndex === 0) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(1)
      );
    } else if (selectedIndex === selectedProductIds.length - 1) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(0, selectedIndex),
        selectedProductIds.slice(selectedIndex + 1)
      );
    }

    setSelectedProductIds(newSelectedProductIds);
  };
  const handleApplyFilters = () => {
    getProductsAssigned(searchedText.current);
  };

  useEffect(() => {
    getProductsAssigned(searchedText.current);
  }, [page, limit]);

  useEffect(() => {
    const tableData = productsAssigned.map((assignment) => {
      return [
        capitalizeFirstLetterArray(
          `${assignment.firstName} ${assignment.lastName}`
        ),
        assignment.rut,
        assignment.phone,
        assignment.email,
        capitalizeFirstLetterArray(
          `${assignment.doctor.name} ${assignment.doctor.lastName}`
        ),
        assignment.doctor.rut,
        assignment.doctor.email,
        assignment.address,
        moment(assignment.createdAt).format("DD-MM-YYY"),
        moment(assignment.updatedAt).format("DD-MM-YYY"),
        assignment.products.reduce((acc, curr) => {
          return `${acc}${curr.name} (${curr._id})`;
        }, ""),
        getAssignmentStatusNames(assignment.status),
      ];
    });
    tableBody.current = tableData;
  }, [productsAssigned]);
  const optionsToolbar = [
    {
      label: "Exportar excel",
      action: async (e) => {
        e.preventDefault();
        try {
          setLoading(true);
          const { status, response } = await productsServices.exportAssignments(
            {
              text: searchedText.current,
              page,
              limit,
              status: selectedOrderStatus,
              ...(startDate && { startDate: startDate }),
              ...(endDate && { endDate: endDate }),
              comuna: selectedComunas,
            }
          );
          if (status === 200) {
            var blob = new Blob([response], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "asignaciones.xlsx";
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
        } catch (error) {
          setToast(true);
          setToastMessage("Error al exportar los datos. Intente de nuevo.");
        } finally {
          setLoading(false);
        }
      },
    },
  ];
  if (authState.user.role.name !== "MASTER") {
    optionsToolbar.push({
      label: "Asignar",
      action: (e) => {
        setOpenModalAsign(true);
      },
    });
  }

  const handleUpdateOrderStatus = async (data) => {
    const { orderId } = data;
    setLoadingOrderStatusUpdates((prev) => [...prev, orderId]);
    orderServices
      .updateOrderStatus(data)
      .then((res) => {
        if (res.status === 200) {
          getProductsAssigned(searchedText.current).finally(() => {
            setLoadingOrderStatusUpdates((prev) =>
              prev.filter((assigment) => assigment !== orderId)
            );
          });
        }
      })
      .catch((err) => {
        setToast(true);
        setToastMessage(err.message);
        setLoadingOrderStatusUpdates((prev) =>
          prev.filter((assigment) => assigment !== orderId)
        );
      });
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Toast
          message={toastMessage}
          open={toast}
          close={() => setToast(false)}
        />
        <ConfirmationModal
          open={openAlert}
          setOpenAlert={setOpenAlert}
          setConfirmAction={() => onDelete()}
        />
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            {openModalAsign && (
              <AssignProduct
                reload={() => setReload(true)}
                open={openModalAsign}
                close={() => setOpenModalAsign(false)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                onFilter={(text) => {
                  getProductsAssigned(text);
                  searchedText.current = text;
                }}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                options={optionsToolbar}
              />

              <Box
                data-id="filter-container"
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                style={{ flexWrap: "wrap", marginBottom: 12, gap: 8 }}
              >
                <KeyboardDatePicker
                  className={classes.formControl}
                  variant="inline"
                  margin="normal"
                  label="Fecha de inicio"
                  format="DD/MM/YYYY"
                  value={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                    setEndDate(moment());
                  }}
                  openTo="year"
                  views={["year", "date"]}
                  disableToolbar
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  maxDate={moment()}
                />
                <KeyboardDatePicker
                  className={classes.formControl}
                  variant="inline"
                  margin="normal"
                  label="Fecha de fin"
                  format="DD/MM/YYYY"
                  value={endDate}
                  onChange={(date) => setEndDate(date)}
                  openTo="year"
                  views={["year", "date"]}
                  disableToolbar
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  disabled={!startDate}
                  minDate={startDate}
                  maxDate={moment()}
                />
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-mutiple-checkbox-label">
                    Comunas
                  </InputLabel>
                  <Select
                    labelId="demo-mutiple-checkbox-label"
                    multiple
                    value={selectedComunas}
                    onChange={(e) => setSelectedComunas(e.target.value)}
                    input={<Input />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 4.5 + 8,
                          width: 250,
                        },
                      },
                    }}
                  >
                    {comunasArray.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={selectedComunas.indexOf(name) > -1}
                        />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-label">
                    Estado de entrega
                  </InputLabel>
                  <Select
                    labelId="demo-simple-label"
                    value={selectedOrderStatus}
                    onChange={(e) => setSelectedOrder(e.target.value)}
                    input={<Input />}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 4.5 + 8,
                          width: 250,
                        },
                      },
                    }}
                  >
                    {orderStatuses.map((status) => (
                      <MenuItem key={status._id} value={status._id}>
                        {status.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box style={{ display: "flex", alignItems: "center", flex: 1 }}>
                  <Button
                    style={{ flex: 1 }}
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={handleApplyFilters}
                  >
                    Aplicar
                  </Button>
                  <IconButton onClick={removeFilters}>
                    <ClearIcon />
                  </IconButton>
                </Box>
              </Box>
              <BaseTable
                boxProps={{ style: { height: "calc(100vh - 250px)" } }}
              >
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell
                      width={1}
                      style={{ width: "1rem" }}
                    ></StyledTableCell>
                    <StyledTableCell>Código</StyledTableCell>
                    <StyledTableCell>Doctor + RUT</StyledTableCell>
                    <StyledTableCell>Paciente + RUT</StyledTableCell>
                    <StyledTableCell>Email del Paciente</StyledTableCell>
                    <StyledTableCell style={{ minWidth: "276px" }}>
                      Estatus de la Asignación
                    </StyledTableCell>
                    <StyledTableCell>Editar estatus de envio</StyledTableCell>
                    <StyledTableCell>Comuna</StyledTableCell>
                    <StyledTableCell>Fecha de Asignación</StyledTableCell>
                    <StyledTableCell>Fecha de Actualización</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {productsAssigned.map((assignment, index) => {
                    const assignmentCreateDate = moment(assignment.createdAt);
                    const currentMonth = moment();
                    const isCurrentMonth = assignmentCreateDate.isSame(
                      currentMonth,
                      "month"
                    );
                    const nameRutPatient =
                      roleName === "MASTER" && !isCurrentMonth
                        ? "*******"
                        : capitalizeFirstLetterArray(
                            `${assignment.firstName} ${assignment.lastName} ${assignment.rut}`
                          );

                    return (
                      <>
                        <StyledTableRow
                          key={assignment._id}
                          className={classes.row}
                          data-state={
                            loadingOrderStatusUpdates.includes(assignment._id)
                              ? "loading"
                              : ""
                          }
                        >
                          <StyledTableCell
                            style={{
                              width: "1rem",
                            }}
                          >
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() =>
                                handleSelectOne(null, assignment._id)
                              }
                            >
                              {selectedProductIds.indexOf(assignment._id) !==
                              -1 ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          </StyledTableCell>
                          <StyledTableCell>
                            {assignment.orderCode || "No asignado"}
                          </StyledTableCell>
                          <StyledTableCell>{`${assignment.doctor.name} ${assignment.doctor.lastName} ${assignment.doctor.rut}`}</StyledTableCell>
                          <StyledTableCell>{nameRutPatient}</StyledTableCell>
                          <StyledTableCell>{`${assignment.email}`}</StyledTableCell>
                          <StyledTableCell>
                            {getAssignmentStatusNames(assignment.status)}

                            <HandleResendEmailModal
                              assignment={assignment}
                              index={index}
                            />
                          </StyledTableCell>

                          <StyledTableCell>
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={() => {
                                setOpenModal(true);
                                setAssingmentId(assignment._id);
                                setAssignment({
                                  orderCode: assignment.orderCode || "",
                                  status: assignment.status,
                                  inDeliveryComments:
                                    assignment.inDeliveryComments || "",
                                });
                              }}
                            >
                              Editar
                            </Button>
                          </StyledTableCell>

                          <StyledTableCell>
                            {`${getComuna(assignment.address)}`}
                          </StyledTableCell>
                          <StyledTableCell>
                            {moment(assignment.createdAt).format(
                              "DD/MM/YYYY hh:mm a"
                            )}
                          </StyledTableCell>
                          <StyledTableCell>
                            {assignment.updatedAt
                              ? moment(assignment.updatedAt).format(
                                  "DD/MM/YYYY hh:mm a"
                                )
                              : "N/A"}
                          </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow
                          hover
                          key={`${assignment._id}-${index + 1}`}
                        >
                          <TableCell
                            style={{
                              paddingBottom: 0,
                              paddingTop: 0,
                              borderBottom: 0,
                            }}
                            colSpan={10}
                          >
                            <Collapse
                              in={
                                selectedProductIds.indexOf(assignment._id) !==
                                -1
                              }
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box>
                                {/* <Typography variant="h6" gutterBottom component="div">
                              Productos asociados:
                            </Typography> */}
                                <Table size="small" aria-label="purchases">
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell2>
                                        Nombre del Producto
                                      </StyledTableCell2>
                                      <StyledTableCell2>
                                        Concentración
                                      </StyledTableCell2>
                                      <StyledTableCell2>
                                        Cantidad
                                      </StyledTableCell2>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {assignment.products.map((product) => (
                                      <TableRow hover key={product._id}>
                                        <StyledTableCell2>
                                          {product.name}
                                        </StyledTableCell2>
                                        <StyledTableCell2>
                                          {product.concentration}
                                        </StyledTableCell2>
                                        <StyledTableCell2>
                                          {product.requiredQuantity}
                                        </StyledTableCell2>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </StyledTableRow>
                      </>
                    );
                  })}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onRowsPerPageChange={(e) => setLimit(e.target.value)}
                onPageChange={(e, page) => setPage(page + 1)}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>

      {openModal && (
        <EditStatusModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          assigmentId={assigmentId}
          assignment={assignment}
          orderStatuses={orderStatuses}
          handleUpdateOrderStatus={handleUpdateOrderStatus}
          loading={loadingOrderStatusUpdates.includes(assigmentId)}
        />
      )}
    </MuiPickersUtilsProvider>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  formControl: {
    minWidth: 150,
    flex: 1,
  },
  row: {
    '&[data-state="loading"]': {
      filter: "opacity(0.6)",
      "&>*": {
        pointerEvents: "none",
      },
    },
  },
}));
